//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Places from './places.vue';
import Gift from './gift.vue';
import addAnyFormFields from '@/utils/addAnyFormFields';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import HintEmail from '@/components/common/hintEmail.vue';
import D0822Button from '@/components/d0822/fields/button.vue';
import Phone from '@/components/common/phone';
import PrivacyPolicy from '@/components/common/privacyPolicy.vue';
import { getGRecaptchaScore } from '@/utils/grecaptcha';
import handleError from '@/utils/handleError';
import * as Sentry from '@sentry/vue';
import customerIoMixin from '@/mixins/customerIo.mixin';

export default {
  components: {
    Places,
    Gift,
    ValidationObserver,
    ValidationProvider,
    HintEmail,
    D0822Button,
    Phone,
    PrivacyPolicy,
  },
  mixins: [customerIoMixin],
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      rulesAccepted: true,

      // При авторизации через LMS поля с именем и почтой могут быть
      // заблокированы, так как данные берутся с аккаунта LMS
      nameDisabled: false,
      emailDisabled: false,

      formId: 1,

      formBuzy: false,
    };
  },
  computed: {
    withGift() {
      // Подарок за регистрацию. Хардкод, берётся не с сервера
      return this.eventStatus === 'upcoming';
    },
    event() {
      return this.$store.state.event.data;
    },
    eventName() {
      return this.event?.name;
    },
    eventType() {
      return this.event?.type;
    },
    eventDirectionName() {
      const id = this.event?.directionId;
      if (!id) return '';

      const direction =
        this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](id);
      return direction?.name;
    },
    slug() {
      return this.event?.slug;
    },
    eventId() {
      return this.event?.id;
    },
    eventStatus() {
      return this.$store.state.event.eventStatus;
    },
  },
  watch: {
    '$store.state.customerIo.userDataFromCio': {
      handler(dataFromCio) {
        if (!this.$app.user?.email && dataFromCio?.email) {
          this.email = dataFromCio.email;
        }
        if (!this.$app.user?.profile?.phone && dataFromCio?.phone) {
          this.phone = dataFromCio.phone;
        }
        if (!this.$app.user?.name && dataFromCio?.name) {
          this.name = dataFromCio.name;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.preloadFields();

    // Добавить к форме скрытые поля с метаданными.
    // Без setTimeout отрабатывает некорректно
    const ref = this.$refs.validationObserver;
    const addAnyFormFieldsFunction = addAnyFormFields.bind(this);
    setTimeout(() => {
      addAnyFormFieldsFunction({ ref });
    }, 1000);
  },
  methods: {
    sentMessageToSentry(errorMessage) {
      try {
        if (errorMessage && process.client) {
          Sentry.captureMessage(`Webinar form error`, {
            level: 'info',
            extra: {
              errorMessage,
            },
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    /** Заполнить поля данными из аккаунта LMS */
    preloadFields() {
      const user = this.$app?.user;
      const profile = user?.profile;
      if (!profile) return;

      const name = user.name;
      const phone = profile.phone;
      const email = user.email;

      // Если получаем имя из аккаунта LMS, то его ручной ввод выключается
      if (name) {
        this.name = name;
        this.nameDisabled = true;
      }

      // Даже если телефон заполняем из LMS - ручной ввод остаётся
      if (phone) {
        this.phone = phone;
      }

      // Если получаем почту из аккаунта LMS, то её ручной ввод выключается
      if (email) {
        this.email = email;
        this.emailDisabled = true;
      }
    },

    /** Отправление формы */
    async onSubmit() {
      if (this.formBuzy) return;
      this.formBuzy = true;

      this.name = this.name.trim();
      this.email = this.email.trim();
      this.phone = this.phone.trim();

      const isValid = await this.$refs.validationObserver.validate();
      if (!isValid) {
        this.formBuzy = false;
        return;
      }

      try {
        window?.$meter?.event({
          name: 'formSubmit',
          label: 'subscribeOnWebinarForm',
        });
      } catch (e) {
        this.sentMessageToSentry(e.toString());

        console.error(e);
      }

      let data = null;

      try {
        const formData = this.convertFormData();

        const grecaptchaScore = await getGRecaptchaScore.bind(this)();

        data = {
          ...formData,
          name: this.name,
          phone: this.phone,
          email: this.email,
          checkbox: this.rulesAccepted,
          google_score: grecaptchaScore,
        };
      } catch (e) {
        this.sentMessageToSentry(e.toString());

        console.error(e);
      }

      try {
        const url = this.$app.config.current.webinarsCreateLeadUrlAws;

        const response = await this.$axios({
          method: 'post',
          url,
          data,
        });

        this.$store.commit(
          'event/SET_AUTO_WEBINARS_SUBSCRIBER_EMAIL',
          this.email,
        );
        this.$refs.validationObserver?.reset();

        this.$gtm?.push({
          event: 'webinarLead',
          eventCategory: 'subscription', // Метки для GTM
          user_email: this.email,
          user_phone: this.phone, // Данные подписчика
          schedule_event_name: this.eventName,
          schedule_event_id: this.eventId,
          schedule_event_slug: this.slug, // Данные события
          schedule_event_type: this.eventType,
          schedule_event_direction: this.eventDirectionName, // Тип и вертикаль события
          schedule_event_form_type: 'new', // Тип формы - старая или новая
        });

        this.$gtm?.push({
          event: 'autoEvent',
          eventCategory: 'click',
          eventAction: 'webinar_lead',
          eventLabel: this.slug,
        });

        if (response.status === 200) {
          try {
            window?.$meter?.event({
              name: 'formSuccess',
              label: 'subscribeOnWebinarForm',
            });
          } catch (e) {
            this.sentMessageToSentry(e.toString());

            console.error(e);
          }
        }

        // Диалоговое окно-поздравление с успешной регистрацией
        this.$store.dispatch('modalNotify/OPEN', {
          title: this.$t(`eventos.register.success.title`),
          description: this.$t(`eventos.register.success.text`),
          action: this.$t(`eventos.register.success.button`),
        });

        // Если форма была открыта через диалоговое окно - оно закроется
        this.$store.commit('event/SET_DISPLAY_REGISTER_DIALOG', false);

        // Сохраняем информацию о том, что юзер уже подписан на вебинар
        this.$store.commit('event/SET_IS_SUBSCRIBED', true);

        this.name = '';
        this.phone = '';
        this.email = '';
      } catch (e) {
        this.sentMessageToSentry(e.toString());

        handleError.bind(this)(e);
      } finally {
        this.formBuzy = false;
      }
    },
    convertFormData() {
      const formData = new FormData(this.$refs.form);
      return Object.fromEntries(formData);
    },
  },
};
